<form [formGroup]="voteOptionForm" class="flex flex-col w-full gap-4">
    <div 
        class="flex flex-col gap-4 w-full lg:flex-row"
        [ngClass]="[mod3===0 ? 'lg:children:w-1/3' : 'lg:children:w-1/2']"
    >
        <app-vote-option-card
            *ngFor="let voteOptionKey of voteOptionKeys"
            [id]="voteOptionKey + '-vote-option'"
            [voteOptionId] = "voteOptionKey"
            [voteOptions] = "voteOptions"
            [formControlName]="voteOptionKey"
        ></app-vote-option-card>
      
    </div>
</form>